import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

import { IMultiSelectOption, IMultiSelectSettings, IMultiSelectTexts } from 'ngx-bootstrap-multiselect';
import { pedidoSetoresGep } from '../pedido-setor-gep';

@Component({
    selector: 'sgt-pedido-setor-gep-multiselect',
    templateUrl: './pedido-setor-gep-multiselect.component.html',
    styleUrls: ['./pedido-setor-gep-multiselect.component.less']
})
export class PedidoSetorGepMultiselectComponent implements OnInit {
    /** Setores GEP selecionados */
    @Input() setoresGep: number[];
    /** Ao alterar a seleção dos setores GEP */
    @Output() setoresGepChange = new EventEmitter<number[]>();

    // Settings
    settings: IMultiSelectSettings;
    @Input() pullRight = false;
    @Input() enableSearch = true;
    @Input() showCheckAll = true;
    @Input() showUncheckAll = true;
    @Input() dynamicTitleMaxItems = 0;
    @Input() fixedTitle = false;
    /** Se deve exibir o multiselect acima */
    @Input() dropup = false;
    /** Se deve desabilitar o multiselect */
    @Input() disabled = false;

    // Texts
    texts: IMultiSelectTexts;
    @Input() checkAll = 'Selecionar Todos';
    @Input() uncheckAll = 'Limpar';
    @Input() defaultTitle = 'Nenhum Setor GEP';
    @Input() checked = 'Setor GEP';
    @Input() checkedPlural = 'Setores GEP';
    @Input() searchPlaceholder = 'Pesquisar...';
    @Input() allSelected = 'Todos Selecionados';
    @Input() searchEmptyResult = 'Nenhum setor encontrado';
    @Input() searchNoRenderText = 'Digite para pesquisar';

    // Options
    options: IMultiSelectOption[];

    constructor() { }

    ngOnInit() {
        // Settings
        this.settings = {
            pullRight: this.pullRight,
            enableSearch: this.enableSearch,
            containerClasses: `container-multiselect container-multiselect-pedido-setor-gep ${this.dropup ? 'dropup' : 'dropdown'}`,
            showCheckAll: this.showCheckAll,
            showUncheckAll: this.showUncheckAll,
            dynamicTitleMaxItems: this.dynamicTitleMaxItems,
            fixedTitle: this.fixedTitle
        };
        // Texts
        this.texts = {
            checkAll: this.checkAll,
            uncheckAll: this.uncheckAll,
            defaultTitle: this.defaultTitle,
            checked: this.checked,
            checkedPlural: this.checkedPlural,
            searchPlaceholder: this.searchPlaceholder,
            allSelected: this.allSelected,
            searchEmptyResult: this.searchEmptyResult,
            searchNoRenderText: this.searchNoRenderText
        };

        this.create();
    }

    /** Cria os setores GEP para o multiselect */
    private create() {
        this.options = [];
        const selects: IMultiSelectOption[] = [];
        pedidoSetoresGep.forEach(setorGep => {
            selects.push({
                id: setorGep.id,
                name: setorGep.nome
            });
        });
        this.options = selects;
    }

    /** Ao alterar a seleção dos setores GEP */
    onChange() {
        this.setoresGepChange.emit(this.setoresGep);
    }
}
